import * as a from "./actions";
import * as m from "./mutations";
import state from "./state";

import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchPaginatedNotificationsCommand, FetchPaginatedNotificationsReqData } from "@/model/communication/notification/FetchPaginatedNotificationsCommand";
import { FetchPaginatedNotificationsResData } from "@/model/communication/notification/FetchPaginatedNotificationsResData";
import { GetTotalNotReadNotificationsCommand } from "@/model/communication/notification/GetTotalNotReadNotificationsCommand";
import { GetTotalNotReadNotificationsResData } from "@/model/communication/notification/GetTotalNotReadNotificationsResData";

export default {
    state,
    mutations: {
        [m.SET_UPDATENOTIFICATIONS](state, payload) {
            state.updateNotifications = payload.notifications;
            state.updateNotifications_length = payload.length;
            state.updateDistinctDevices = payload.distinctDevices;
        },
        [m.SET_SECURITYNOTIFICATIONS](state, payload) {
            state.securityNotifications = payload.notifications;
            state.securityNotifications_length = payload.length;
            state.securityDistinctDevices = payload.distinctDevices;
        },
        [m.SET_ONETIMECODENOTIFICATIONS](state, payload) {
            state.oneTimeCodeNotifications = payload.notifications;
            state.oneTimeCodeNotifications_length = payload.length;
            state.oneTimeCodeDistinctDevices = payload.distinctDevices;
        },
        [m.SET_NOT_READ](state, payload) {
            state.notificationTypes = payload.notificationTypes;
            state.totalNotRead = payload.totalNotRead;
            state.notReadList = payload.notReadList;
        },
        [m.SET_FILTER_AND_OPTIONS](state, payload) {
            state.currentFilter = payload.currentFilter;
            state.currentOptions = payload.currentOptions;
        },
    },

    actions: {
        async [a.TOTAL_NOT_READ_NOTIFICATIONS]({ commit }) {
            try {
                let res: GetTotalNotReadNotificationsResData = await new GetTotalNotReadNotificationsCommand().execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    let notificationTypes = [];
                    let totalNotRead = 0;
                    let notReadList = [];

                    if (res.unreadNotifications) {
                        for (let [key, value] of res.unreadNotifications) {
                            notificationTypes.push(key);
                            let listItem = {};
                            listItem["notificationType"] = key;
                            listItem["notRead"] = value;
                            notReadList.push(listItem);
                            totalNotRead = totalNotRead + value;
                        }

                        commit(m.SET_NOT_READ, {
                            notificationTypes: notificationTypes,
                            totalNotRead: totalNotRead,
                            notReadList: notReadList,
                        });
                    } else {
                        console.log("error fetching notification, res: ", res);
                        if (res.message != "PermissionDenied") {
                            console.log("throw exc now");
                            throw Error("error fetching notifications");
                        }
                    }
                } else if (res.responseStatus == ApiResponseStatusEnum.UnAuthorized || res.responseStatus == ApiResponseStatusEnum.Error) {
                    throw Error("error fetching notifications");
                }
            } catch (err) {
                console.log("location reload now");
                location.reload();
            }
        },

        async [a.FETCH_NOTIFICATIONS]({ commit }, { filter, options }) {
            let reqData = new FetchPaginatedNotificationsReqData();
            reqData.startDate = filter.StartDate;
            reqData.endDate = filter.EndDate;
            reqData.notificationTypeListFilter = filter.NotificationTypeListFilter;
            reqData.markedAsRead = filter.MarkedAsRead;
            reqData.resultCode = filter.ResultCode;
            reqData.device = filter.Device;
            reqData.offset = (options.page - 1) * options.itemsPerPage;
            reqData.queryLimit = options.itemsPerPage;
            reqData.orderBy = options.sortBy;
            reqData.orderByDescending = options.sortDesc;
            let response: FetchPaginatedNotificationsResData = await new FetchPaginatedNotificationsCommand(reqData).execute();

            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                commit(m.SET_FILTER_AND_OPTIONS, {
                    currentFilter: filter,
                    currentOptions: options,
                });
                if (filter.NotificationTypeListFilter[0] == "Update") {
                    commit(m.SET_UPDATENOTIFICATIONS, {
                        notifications: response.notifications,
                        length: response.paginatedTotalItems,
                        distinctDevices: response.distinctDevices,
                    });
                }
                if (filter.NotificationTypeListFilter == "Security") {
                    commit(m.SET_SECURITYNOTIFICATIONS, {
                        notifications: response.notifications,
                        length: response.paginatedTotalItems,
                        distinctDevices: response.distinctDevices,
                    });
                }
                if (filter.NotificationTypeListFilter == "OneTimeCode") {
                    commit(m.SET_ONETIMECODENOTIFICATIONS, {
                        notifications: response.notifications,
                        length: response.paginatedTotalItems,
                        distinctDevices: response.distinctDevices,
                    });
                }
            }
        },
    },
};
